import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import LanguageSwitcher from './components/LanguageSwitcher';
import Home from './pages/Home';
import Products from './pages/Products';
import About from './pages/About';
import Contact from './pages/Contact';
import CaseStudies from './pages/CaseStudies';
import { useTranslation } from 'react-i18next';
import './i18n';
import './App.css';

function App() {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <BrowserRouter>
      <div className="App">
        <nav className="navbar">
          <div className="nav-brand">
            <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none', color: 'inherit' }}>
              <img src="/images/logo.jpg" alt="Jieheng Stone Logo" className="nav-logo" />
              {t('company.name')}
            </Link>
          </div>
          <div className="nav-spacer" />
          <div className={`nav-links${menuOpen ? ' show' : ''}`} id="main-nav-links">
            <Link to="/" onClick={() => setMenuOpen(false)}>{t('nav.home')}</Link>
            <Link to="/products" onClick={() => setMenuOpen(false)}>{t('nav.products')}</Link>
            <Link to="/cases" onClick={() => setMenuOpen(false)}>{t('caseStudies.title')}</Link>
            <Link to="/about" onClick={() => setMenuOpen(false)}>{t('nav.about')}</Link>
            <Link to="/contact" onClick={() => setMenuOpen(false)}>{t('nav.contact')}</Link>
            <div className="mobile-lang-switcher">
              <LanguageSwitcher />
            </div>
          </div>
          <div className="desktop-lang-switcher">
            <LanguageSwitcher />
          </div>
          <button
            className={`hamburger${menuOpen ? ' open' : ''}`}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            aria-controls="main-nav-links"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </button>
        </nav>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/cases" element={<CaseStudies />} />
        </Routes>

        <footer className="footer">
          <div className="footer-content">
            <div className="footer-section">
              <h3>{t('company.name')}</h3>
              <p>{t('footer.description')}</p>
            </div>
            <div className="footer-section">
              <h3>{t('contact.title')}</h3>
              <p>{t('contact.email')}: jiehengstone@gmail.com</p>
              <p>{t('contact.phone')}: +86 18859480999</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 {t('company.name')}. {t('footer.rights')}</p>
          </div>
        </footer>
      </div>
    </BrowserRouter>
  );
}

export default App;
